import { useState } from "react";
import axios from "axios";

/**
 * Custom hook for uploading data to an index.
 * @returns An object containing the data, setData function, loading state, and indexFiles function.
 */
const useUploadToIndex = () => {
    const [data, setData] = useState<any>({});
    const [loading, setLoading] = useState(false);

    const API_URL =
        "https://funcapp-westus-utils-kai-pmr-f8g2fdb6fsfkaqh7.westus-01.azurewebsites.net/api/llm_doc_loader?code=mnSluOsziLF9VW30M_4d-WyKH582fnCYSqlGBe-mm0LLAzFulpDNFQ==";

    /**
     * Uploads files to the index.
     * @param reqBody - The request body containing the files to be uploaded.
     */
    const indexFiles = async (reqBody: any) => {
        try {
            setLoading(true);
            const { data: response } = await axios.post<any>(API_URL, reqBody);
            setData(response);
        } catch (error) {
            setData(null);
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return { data, setData, loading, indexFiles };
};

export default useUploadToIndex;
